import { DataMap, Monitor } from '../../classes';
import { RawResponseTime } from '../../types';

export const buildDataMapContainer = (monitors: Monitor[]): DataMap[] => {
  return monitors.map(monitor => {
    
    return buildDataMap(monitor);
  });
}

const buildDataMap = (monitor: Monitor): DataMap => {
  const dataMap = new DataMap(monitor);
  buildTimesDataMap(dataMap, monitor.responseTimes, Math.floor(Date.now() / 1000 - 84600), Math.floor(Date.now() / 1000));
  return dataMap;
}

const buildTimesDataMap = (
  currentDataMap: DataMap,
  times: RawResponseTime[],
  start: number,
  end: number,
): DataMap => {
  if(currentDataMap.length() === 1) {
    currentDataMap.buildMap(start, end);
    currentDataMap.populateMap(times);
  } else {
    currentDataMap.updateMap(times, start);
  }
  if(currentDataMap.monitor.type === "transfer") {
    currentDataMap.setTransmitFailedDurationsToLongestDuration();
  }
  return currentDataMap;
}






// WEBPACK FOOTER //
// ./src/utils/handle-data/buildDataMapContainer.ts